module.exports = __webpack_public_path__ + "img/icon_map_62_off_001.9ff57c9b.png";